import { useEffect } from 'react'

import { revalidateRail } from '@/lib/chat/revalidateRail'
import { onDraftStatusChanged, onExperimentStatusChanged } from '@/lib/services/websocket'

/**
 * Keeps the Recent rail's study rows fresh: a draft or experiment status event
 * (launch, archive, run progress) refetches the rail and nothing else.
 */
export function useRailStudyRefresh(): void {
  useEffect(() => {
    const offExperiment = onExperimentStatusChanged(() => {
      revalidateRail()
    })
    const offDraft = onDraftStatusChanged(() => {
      revalidateRail()
    })
    return () => {
      offExperiment()
      offDraft()
    }
  }, [])
}
